import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
export function Slide2WhyThisMatters() {
  const cards = [{
    stage: 'Pre-Congress',
    challenge: 'HCPs are not yet aware or interested.',
    objective: 'Seed the clinical problem and pre-qualify interest.'
  }, {
    stage: 'Vicinity',
    challenge: 'HCPs are nearby but not yet engaged.',
    objective: 'Capture attention before they reach the congress floor.'
  }, {
    stage: 'Venue',
    challenge: 'The message gets lost in congress noise.',
    objective: 'Reinforce the agenda and point toward the booth.'
  }, {
    stage: 'Aisle',
    challenge: 'HCPs pass by without wanting a full conversation.',
    objective: 'Break the barrier with a low-friction interaction.'
  }, {
    stage: 'Booth',
    challenge: 'Conversations are not always qualified or captured.',
    objective: 'Deepen engagement and capture preferences or next steps.'
  }, {
    stage: 'Post-Congress',
    challenge: 'Follow-up is often generic.',
    objective: 'Continue the journey based on actual engagement data.'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-16 md:pb-24 relative overflow-hidden" data-id="element-105">
      <header className="mb-12" data-id="element-106">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-107">
          Different moments. Different challenges.{' '}
          <span className="text-[#E60012]" data-id="element-108">Same methodology.</span>
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-109">
          Every stage of the congress journey requires a different engagement
          strategy.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-110">
        {cards.map((card, index) => <motion.div key={card.stage} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex flex-col hover:shadow-md transition-shadow" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2 + index * 0.1
      }} data-id="element-111">
            <div className="inline-block px-3 py-1 bg-[#E60012]/10 text-[#E60012] rounded-full text-xs font-bold uppercase tracking-wider mb-6 w-max" data-id="element-112">
              {card.stage}
            </div>

            <div className="flex-1 space-y-6" data-id="element-113">
              <div data-id="element-114">
                <div className="flex items-center gap-2 mb-2 text-[#4A5568]" data-id="element-115">
                  <AlertCircle className="w-4 h-4 text-[#E60012]" data-id="element-116" />
                  <h4 className="font-semibold text-sm uppercase tracking-wide" data-id="element-117">
                    Challenge
                  </h4>
                </div>
                <p className="text-[#2D3748] font-medium" data-id="element-118">{card.challenge}</p>
              </div>

              <div className="h-px w-full bg-gray-100" data-id="element-119" />

              <div data-id="element-120">
                <div className="flex items-center gap-2 mb-2 text-[#4A5568]" data-id="element-121">
                  <CheckCircle2 className="w-4 h-4 text-[#6B46C1]" data-id="element-122" />
                  <h4 className="font-semibold text-sm uppercase tracking-wide" data-id="element-123">
                    Objective
                  </h4>
                </div>
                <p className="text-[#2D3748]" data-id="element-124">{card.objective}</p>
              </div>
            </div>
          </motion.div>)}
      </main>
    </div>;
}